import React, { useEffect } from "react";
import { isNil } from "ramda";
import { useParams } from "react-router-dom";
import useSession from "../../../effects/useSession";
import { ApplicationState } from "../../../store";
import Layout from "../../Layout";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid, Paper, Box } from "@mui/material";
import pageStyles from "./../../../pages/pageStyles";
import { fetchRequest } from "../../../store/processor/actions";
import PageHeading from "../../../common/pageHeading/PageHeading";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import ProcessorViewDetail from "./ProcessorViewDetail";
import { Data } from "../../../store/processor/types";

const ProcessorView = () => {
  const dispatch = useDispatch();
  const classes = pageStyles();
  const { id } = useParams<{ id: string }>();

  const session = useSession();
  useEffect(() => {
    dispatch(fetchRequest(id));
  }, []);

  const processor = useSelector((state: ApplicationState) => state.processor);
  const processorData =
    processor.data?.data?.length && (processor.data.data[0] as Data);

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper>
                <PageHeading heading="View Processor" />
              </Paper>
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {!isNil(id) && isNil(processorData) ? (
                  <ProgressIndicator />
                ) : (
                  <Box style={{ position: "relative" }}>
                    <ProcessorViewDetail
                      processorData={processorData as Data}
                    />
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default ProcessorView;
